import { combineReducers } from 'redux';
import mobileToken from './mobileToken';

const reducers = combineReducers({
  mobileToken,
});

export default reducers;
